import { Injectable, Injector } from '@angular/core';
import Session from 'supertokens-web-js/recipe/session';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
    HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, retry } from 'rxjs/operators';
import { SupertokensService } from '../supertokens.service';
import { AuthService } from 'app/core/auth/auth.service';
import { DialogsService } from '../dialog.service';

@Injectable()
export class RefreshSupertokensInterceptor implements HttpInterceptor {
    constructor(
        private supertokensSvc: SupertokensService,
        private injector: Injector,
        private authService: AuthService,
        private dialogsService: DialogsService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log("ERROR: " + error.message);
                console.log("STATUS: " + error.status);

                if (error.status === 401) {
                    console.log('inside if');

                    // Lógica para refrescar el token
                    //Documentación https://supertokens.com/docs/emailpassword/common-customizations/sessions/ssr#2-do-jwt-verification
                    return from(Session.attemptRefreshingSession()).pipe(
                        switchMap(() => {
                            const clonedRequest = req.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${this.supertokensSvc.accesToken}`,
                                },
                            });

                            return next.handle(clonedRequest);
                        }),
                        catchError((err) => {
                            this.dialogsService.error("Error de autenticación", "Su sesión ha expirado, por favor inicie sesión nuevamente").afterClosed().subscribe(() => {
                                this.authService.signOut().subscribe(() => {
                                    location.reload();
                                });
                            });
                            return of(err);
                        })
                    );
                } else {
                    console.log('inside else');
                    // Si no es un error 401, simplemente se lanza el error
                    return throwError(error);
                }
            })
        );
    }
}
export const RefreshSupertokensInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: RefreshSupertokensInterceptor,
    multi: true,
};
